// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { get } from "@insite/client-framework/Services/ApiService";

export interface MonthlyDeal {
    productId: string;
    productTitle: string;
    productDescription: string;
    productImage: string;
    brandImage: string;
    unitOfMeasure: string;
    availableDate: Date;
    availableDateDisplay: string;
    product?: ProductContextModel;
    pageUrl?: string;
}

const serviceUri = "api/custom/monthlydeals";

export async function getMonthlyDeals() {
    const monthlyDeals = await get<MonthlyDeal[]>(`${serviceUri}`).catch(err => err);
    return monthlyDeals;
}
